<!-- 本科-个人信息页-自我介绍信息 -->
<template>
  <div class='personal-detail-wrap'>
    <div class='detail-container has-border'>
      <div class='personal-detail en'
           v-if='!isEditEn'>
        <h4>Information for mentee introduction</h4>
        <ul v-if="otherInfo.ugdFacts && otherInfo.ugdFacts.length > 0">
          <li v-for='(item, index) in otherInfo.ugdFacts'
              :key='index'>
            <span class='personal-detail-name'>Interesting Facts {{index + 1}}：</span>
            <span class='personal-detail-val'>{{item}}</span>
          </li>
        </ul>
        <div class="ugd-high-school">
          <span class='personal-detail-name'>Honors and activities in high school：</span>
          <span class='personal-detail-val'>{{otherInfo.allHigh}}</span>
        </div>
      </div>
      <div class='personal-form en'
           v-if='isEditEn'>
        <h4>Information for mentee introduction</h4>
        <Form ref="formValidateEn"
              :model="formValidateEn"
              :rules="ruleValidateEn"
              :label-width="300">
          <div class="base-form-item">
            <FormItem v-for="(item,index) in formValidateEn.ugdFacts"
                      :key="index">
              <Input v-model.trim="formValidateEn.ugdFacts[index]"
                     :placeholder="otherInfoPlaceholder[index]"></Input>
            </FormItem>
            <FormItem>
              <Input v-model="formValidateEn.allHigh"
                     placeholder="Describe your activities and honors in your high school"
                     type="textarea"
                     :rows='5'></Input>
            </FormItem>
          </div>
          <div class="sub-btn">
            <Button :loading='hasSaveIntroduction'
                    @click="saveEn">Save</Button>
          </div>
        </Form>
      </div>
      <div class='personal-btn en'>
        <a href='javascript: void(0)'
           @click="goEditEn">{{isEditEn ? 'back' : 'Edit'}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import './personal-detail.less'
import { getBasicinfo, putFacts } from '@/api/talents'
export default {
  name: '',
  props: {},
  components: {},
  data () {
    return {
      basicInfo: {},
      otherInfo: {
        ugdFacts: ['', '', '', '', '', '', '']
      },
      isEditEn: false,
      // En表单
      formValidateEn: {
        ugdFacts: ['', '', '', '', '', '', ''],
        allHigh: ''
      },
      otherInfoPlaceholder: ['eg. First prize in the American Mathematics Competition.', 'eg. Barely spoke English at 14, got admitted to Amherst Collge with full schorlarship at 17.', 'eg. Engaged with policy makers in setting up a sovereign wealth fund.', 'eg. Published a book of photography works as a senior in college.', 'eg. Solo travelled to 16 cities in 4 different countries in 2 months to conduct architectural research on Nagie Travel Fellowship.'],
      ruleValidateEn: {},
      // loading-自我介绍-避免重复提交
      hasSaveIntroduction: false
    }
  },
  computed: {},
  mounted () {
    this.getIntroduction()
  },
  methods: {
    // Introductio Info
    getIntroduction () {
      getBasicinfo().then(res => {
        this.basicInfo = res.data.basicInfo
        if (res.data.basicInfo && res.data.basicInfo.otherInfo) {
          if (res.data.basicInfo.otherInfo.ugdFacts.length > 0) {
            this.otherInfo = res.data.basicInfo.otherInfo
            this.formValidateEn = res.data.basicInfo.otherInfo
          }
          this.otherInfo.allHigh = res.data.basicInfo.otherInfo.allHigh
          this.formValidateEn.allHigh = res.data.basicInfo.otherInfo.allHigh
        }
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
      })
    },

    // edit-back
    goEditEn () {
      this.isEditEn = !this.isEditEn
      this.getIntroduction()
    },
    // Save
    saveEn () {
      console.log('111')
      this.hasSaveIntroduction = true
      putFacts(this.formValidateEn).then(res => {
        this.hasSaveIntroduction = false
        this.goEditEn()
      }).catch(error => {
        this.$ugd_message(error.message, 'error')
        this.hasSaveIntroduction = false
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
